import { UUID } from "@screencloud/uuid";
import { useState } from "react";
import { ContentInput, DemoChannelContentType } from "src/types.g";

export const useTemplateSelection = () => {
  const [selectedTemplateIds, setSelectedTemplateIds] = useState<UUID[]>([]);

  const handleTemplateClick = (templateId: UUID) => {
    setSelectedTemplateIds((prevIds) =>
      prevIds.includes(templateId)
        ? prevIds.filter((id) => id !== templateId)
        : [...prevIds, templateId],
    );
  };

  const getCreateDemoChannelParams = (): ContentInput => {
    return {
      type: DemoChannelContentType.Canvas,
      refIdData: selectedTemplateIds,
    };
  };

  const disableNextButton = selectedTemplateIds.length === 0;

  return {
    selectedTemplateIds,
    handleTemplateClick,
    getCreateDemoChannelParams,
    disableNextButton,
  };
};
